import { render, staticRenderFns } from "./manage-fiche-champ.html?vue&type=template&id=bb6aea10&scoped=true&external"
import script from "./manage-fiche-champ.js?vue&type=script&lang=js&external"
export * from "./manage-fiche-champ.js?vue&type=script&lang=js&external"
import style0 from "./manage-fiche-champ.scss?vue&type=style&index=0&id=bb6aea10&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6aea10",
  null
  
)

export default component.exports